import { paths } from "@src/app/paths"
import { router } from "@src/pages"
import { TourStepBase } from "@src/widgets/onboarding/classes/TourStepBase"
import {
  ONBOARDING_TOURS,
  TOUR_MODAL_PLACEMENTS,
} from "@src/widgets/onboarding/types"
import { OnboardingStepComponentWrapProps } from "@src/widgets/onboarding/ui/tours/OnboardingStepComponentWrap"
import { GeneratingReportsStepUi } from "@src/widgets/onboarding/ui/tours/TransactionHistoryAndReports/steps/GeneratingReportsStepUi"

export class GeneratingReportsStep extends TourStepBase {
  component = GeneratingReportsStepUi
  name = `${ONBOARDING_TOURS.TRANSACTION_HISTORY_AND_REPORTS}_GeneratingReports`

  constructor() {
    super({
      highlightElements: ["#GENERATED_ID_TABLEFILTER_FORM_VOID_1"],
      placement: TOUR_MODAL_PLACEMENTS.BOTTOM,
    })
  }

  action() {
    return router.navigate(paths.reports)
  }

  popupProps(): Omit<OnboardingStepComponentWrapProps, "children"> {
    return {
      subtitle: "Generate detailed reports for financial insight",
      title: "Generating Reports",
    }
  }
}
